/**
 * State and reducer for the Person / CDD onboarding form.
 * Keeps person-specific fields separate from platform onboarding state.
 */

export type PersonOnboardingState = Record<string, string | boolean>;

export const initialPersonOnboardingState: PersonOnboardingState = {
  name: '',
  title: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zipCode: '',
  taxIdSsn: '',
  email: '',
  dateOfBirth: '',
  phoneNumber: '',
  isOwner: false,
};

export type PersonOnboardingAction =
  | {
      type: 'SET_FIELD';
      stateKey: keyof PersonOnboardingState;
      value: string | boolean;
    }
  | { type: 'RESET' };

export const personOnboardingReducer = (
  state: PersonOnboardingState,
  action: PersonOnboardingAction
): PersonOnboardingState => {
  switch (action.type) {
    case 'SET_FIELD':
      return { ...state, [action.stateKey]: action.value };
    case 'RESET':
      return { ...initialPersonOnboardingState };
    default:
      return state;
  }
};
